import { forwardRef } from "react";
import { makeStyles, Menu } from "@material-ui/core";
import { fontColor, menuBackgroundColor, nestedMenuWidth, } from "../utils/configuration";
export const useMenuStyles = makeStyles(() => ({
    "@global": {
        ".MuiPaper-root.MuiMenu-paper.MuiPopover-paper::-webkit-scrollbar": {
            width: 8,
            background: menuBackgroundColor,
        },
        ".MuiPaper-root.MuiMenu-paper.MuiPopover-paper::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(211, 211, 211, 0.7)",
            borderRadius: 16,
        },
    },
    list: {
        color: fontColor,
        pointerEvents: "all",
        width: `${nestedMenuWidth}px !important`,
        background: menuBackgroundColor,
    },
    popover: {
        pointerEvents: "all",
    },
}));
const StyledMenu = forwardRef(({ children, reverseStackingSide, enableBackdrop, MenuListProps, ...props }, ref) => {
    const classes = useMenuStyles();
    return (<Menu ref={ref} style={{ pointerEvents: enableBackdrop ? undefined : "none" }} getContentAnchorEl={null} anchorOrigin={{
            vertical: "top",
            horizontal: !reverseStackingSide ? "right" : "left",
        }} transformOrigin={{
            vertical: "top",
            horizontal: !reverseStackingSide ? "left" : "right",
        }} MenuListProps={{ className: classes.list, ...MenuListProps }} PopoverClasses={{ paper: classes.popover }} {...props}>
        {children}
      </Menu>);
});
export default StyledMenu;
